// extracted by mini-css-extract-plugin
module.exports = {"container":"SituationalAwarenessPage_container__K83Z2","pageContent":"SituationalAwarenessPage_pageContent__ohSdb","demoPanel":"SituationalAwarenessPage_demoPanel___fODj"};